
























































import _ from "lodash";
import { Prop, Component, Vue } from "vue-property-decorator";
import ScheduleEventApi from "../../../api/schedule/schedule-event-api";
import { client } from "../../../api/request";
import { Project, getAssignedProjects } from "../../../api/project-api";
import ScheduleEventSaveRequest from "../../../schedule/usecases/schedule-event-save-request";
import ProjectOption from "@/ui/common/presenters/project-option";
import formatLocaleDate from "@/helpers/formatLocaleDate";

const eventApi = new ScheduleEventApi(client);

// TODO パーミッションがないと開けないようにする
@Component({})
export default class NewScheduleEventModal extends Vue {
  @Prop({ type: Boolean }) projectEditable!: boolean;

  public show(date: Date, projectId?: number) {
    this.init(date, projectId);
    (this.$refs.modal as any).show();
  }

  public hide() {
    (this.$refs.modal as any).hide();
  }

  date = new Date();
  // TODO コンストラクタにまとめる
  event: ScheduleEventSaveRequest = {
    projectId: 0,
    title: "",
    description: "",
    date: new Date(),
    startTime: "00:00",
    endTime: "00:00"
  };

  get heading() {
    return formatLocaleDate(this.event.date);
  }

  // TODO ViewModelにまとめる
  get projectOptions(): ProjectOption[] {
    return this.projects.map(p => new ProjectOption(p));
  }

  async save() {
    await eventApi.save(this.event);
    this.$emit("ok");
    this.hide();
  }

  protected mounted() {
    this.initProjectList();
  }

  private async init(date: Date, projectId?: number) {
    this.event = {
      projectId: projectId || 0,
      title: "",
      description: "",
      date,
      startTime: "12:00",
      endTime: "13:00"
    };
  }

  private projects: Project[] = [];

  private async initProjectList() {
    this.projects = _.orderBy(await getAssignedProjects(), "created", "desc");
  }
}
